import { PageHeader } from "@/components/shared/PageHeader";
import { DocumentsSection } from "@/components/home/DocumentsSection";

const IMG = "https://static.prod-images.emergentagent.com/jobs/19db1358-9c8e-4718-a041-5f96f8d9cb74/images/914d4ffdbec62421e0fb0552b03f4edcea015eb26a64771065e71b8234df1983.jpeg";

export default function Dokument() {
  return (
    <>
      <PageHeader kicker="Dokumentcenter" title="Dokument" subtitle="PM, tilläggsregler, startlistor, kartor och resultat – samlat på ett ställe." image={IMG} />
      <DocumentsSection full hideHeader />
    </>
  );
}
